/* Tab, Oct 29 2026: "Write a review" form (Figma "Curera V7 tab" 39:6172). Markup: snippets/tab-review-form.liquid.
   Opens under the rating row when the existing "Write a review" button is clicked; submits to Judge.me's
   public review endpoint (no token; reviews arrive in Judge.me for approval). */
(function(){
  var ENDPOINT = 'https://judge.me/api/v1/reviews';
  function init(){
    var wr = document.getElementById('tab-wr');
    if (!wr || wr.dataset.ready) return;
    wr.dataset.ready = '1';
    var sec = wr.closest('.review-sec') || document.getElementById('review-sec');
    if (!sec) return;
    var top = sec.querySelector('.review-top');
    var btn = top && top.querySelector('.btn-primary');
    if (!btn) { btn = Array.prototype.find.call(sec.querySelectorAll('a,button'), function(el){ return /write a review/i.test(el.textContent || ''); }); }
    // place the panel under the rating row's divider (Figma: header, line, form, then the list)
    var anchor = top && top.nextElementSibling && top.nextElementSibling.tagName === 'HR' ? top.nextElementSibling : top;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wr, anchor.nextSibling);

    var form = wr.querySelector('.tab-wr__form');
    var thanks = wr.querySelector('.tab-wr__thanks');
    var stars = Array.prototype.slice.call(wr.querySelectorAll('.tab-wr__star'));
    var send = wr.querySelector('.tab-wr__send');
    var formErr = wr.querySelector('.tab-wr__err--form');
    var rating = 0, busy = false;

    function paint(n){ stars.forEach(function(s, i){ s.classList.toggle('is-on', i < n); }); }
    function setRating(n){ rating = n; paint(n); stars.forEach(function(s, i){ s.setAttribute('aria-checked', String(i + 1 === n)); s.tabIndex = (i + 1 === (n || 1)) ? 0 : -1; }); clearErr('rating'); }
    stars.forEach(function(s, i){
      s.addEventListener('click', function(){ setRating(i + 1); });
      s.addEventListener('mouseenter', function(){ paint(i + 1); });
      s.addEventListener('keydown', function(e){
        var k = e.key, n = rating || 0;
        if (k === 'ArrowRight' || k === 'ArrowUp') n = Math.min(5, n + 1); else if (k === 'ArrowLeft' || k === 'ArrowDown') n = Math.max(1, n - 1); else return;
        e.preventDefault(); setRating(n); stars[n - 1].focus();
      });
    });
    var starBox = wr.querySelector('.tab-wr__stars');
    starBox.addEventListener('mouseleave', function(){ paint(rating); });
    setRating(0);

    function field(f){ return wr.querySelector('.tab-wr__field[data-f="' + f + '"]'); }
    function setErr(f, msg){ var el = field(f); if (!el) return; el.classList.add('is-bad'); el.querySelector('.tab-wr__err').textContent = msg; }
    function clearErr(f){ var el = field(f); if (!el) return; el.classList.remove('is-bad'); el.querySelector('.tab-wr__err').textContent = ''; }
    ['body','title','name','email'].forEach(function(f){ var inp = field(f).querySelector('input,textarea'); inp.addEventListener('input', function(){ clearErr(f); }); });

    function open(){
      thanks.hidden = true; form.hidden = false; wr.hidden = false; sec.classList.add('tab-wr-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      var y = wr.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      setTimeout(function(){ (stars[0]).focus({ preventScroll: true }); }, 350);
    }
    function close(){
      wr.hidden = true; sec.classList.remove('tab-wr-open');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); }
    }
    function reset(){ form.reset(); setRating(0); ['rating','body','title','name','email'].forEach(clearErr); formErr.textContent = ''; }
    if (btn) {
      btn.setAttribute('aria-controls', 'tab-wr'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('role', 'button');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if (!wr.hidden && !form.hidden) { close(); btn.focus(); return; }
        if (!thanks.hidden) reset();
        open();
      });
    }
    wr.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !wr.hidden) { close(); if (btn) btn.focus(); } });
    wr.querySelector('.tab-wr__continue').addEventListener('click', function(){ window.location.href = '/collections/all'; });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if (busy) return;
      formErr.textContent = '';
      var v = function(n){ return (form.elements[n].value || '').trim(); };
      var body = v('body'), title = v('title'), name = v('name'), email = v('email'), first = null, bad = false;
      function fail(f, m){ setErr(f, m); bad = true; if (!first) first = f; }
      if (!rating) fail('rating', 'Please choose a star rating.');
      if (!body) fail('body', 'Please write your review.');
      if (!title) fail('title', 'Please add a headline.');
      if (!name) fail('name', 'Please enter your name.');
      if (!email) fail('email', 'Please enter your email.');
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) fail('email', 'Please enter a valid email.');
      if (bad) { var fe = field(first); var t = fe.querySelector('input,textarea,.tab-wr__star'); if (t) t.focus(); return; }
      busy = true; send.disabled = true; send.textContent = 'Sending…';
      var data = new URLSearchParams();
      data.append('shop_domain', wr.dataset.shop);
      data.append('platform', 'shopify');
      if (wr.dataset.productId) data.append('id', wr.dataset.productId);
      data.append('name', name); data.append('email', email); data.append('rating', String(rating));
      data.append('title', title); data.append('body', body);
      fetch(ENDPOINT, { method: 'POST', body: data, mode: 'cors', credentials: 'omit' })
        .then(function(r){ return r.text().then(function(t){ var j = null; try { j = JSON.parse(t); } catch(_){} return { ok: r.ok, status: r.status, json: j }; }); })
        .then(function(res){
          window.__tabWrLast = res;
          if (!res.ok) throw new Error((res.json && (res.json.message || res.json.error)) || ('Error ' + res.status));
          wr.querySelector('.tab-wr__thanks-name').textContent = name.split(/\s+/)[0];
          form.hidden = true; thanks.hidden = false; form.reset(); setRating(0);
          var y = wr.getBoundingClientRect().top + window.pageYOffset - 120;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          thanks.focus({ preventScroll: true });
        })
        .catch(function(err){ formErr.textContent = 'Sorry, your review could not be sent (' + (err && err.message ? err.message : 'network error') + '). Please try again.'; })
        .then(function(){ busy = false; send.disabled = false; send.textContent = 'Send'; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
